import { Outlet, useOutletContext } from "react-router-dom";
import { lazy, Suspense, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Footer from "../layouts/footer";
import AlertComopnent from "../components/views/alert/alertComopnent";
import ErrorHandler from "../components/errorHandler";
import { RootState } from "../store/store";
import useLogin from "../hooks/useLogin";
import LoginRefresher from "./loginRefresher";
import {
  InnerMiddleFooterContainer,
  LandingDiv,
  OuterMiddleFooterContainer
} from "./landing.style";

export type TChildren = {
  children: string | JSX.Element | JSX.Element[];
};

const HeaderNew = lazy(() => import("../components/views/header/headerNew"));

interface IAdjustParentScroll {
  scrollToTop: () => void;
  getScrolledAmount: () => number;
  stopScroll: () => void;
  addScroll: () => void;
}

export const Landing = () => {
  const { onLogInClick } = useLogin();

  const { isLoggedIn, hasCheckedLoggedIn } = useSelector(
    (state: RootState) => state.user
  );

  const scroller = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const pendingProtectedRoute = localStorage.getItem("pendingProtectedRoute");
    const waitingForLogin = localStorage.getItem("waitingForLogin");

    if (hasCheckedLoggedIn && pendingProtectedRoute) {
      if (isLoggedIn && waitingForLogin === "true") {
        localStorage.removeItem("pendingProtectedRoute");
        localStorage.removeItem("waitingForLogin");
        window.location.replace(pendingProtectedRoute);
      } else if (!isLoggedIn && waitingForLogin !== "true") {
        localStorage.setItem("waitingForLogin", "true");
        onLogInClick();
      }
    }
  }, [isLoggedIn, hasCheckedLoggedIn]);

  const scrollToTop = () => {
    scroller.current?.scrollTo(0, 0);
  };

  const getScrolledAmount = (): number => {
    return scroller.current?.scrollTop ?? 0;
  };

  const stopScroll = () => {
    if (scroller.current) {
      scroller.current.style.overflowY = "clip";
    }
  };

  const addScroll = () => {
    if (scroller.current) {
      scroller.current.style.overflowY = "auto";
    }
  };

  return (
    <>
      <AlertComopnent />
      <LandingDiv>
        <ErrorHandler>
          <Suspense>
            <HeaderNew />
          </Suspense>
        </ErrorHandler>
        <OuterMiddleFooterContainer ref={scroller}>
          <InnerMiddleFooterContainer>
            <LoginRefresher>
              <Outlet
                context={{
                  scrollToTop,
                  getScrolledAmount,
                  stopScroll,
                  addScroll
                }}
              />
            </LoginRefresher>
            <Footer />
          </InnerMiddleFooterContainer>
        </OuterMiddleFooterContainer>
      </LandingDiv>
    </>
  );
};

export const useAdjustParentScroll = () =>
  useOutletContext<IAdjustParentScroll>();
